// si il y a une classe nouveautes dans mon html afficher dans cette classe les films d'horreur de 2019

if (document.querySelector(".nouveautes")){
  fetch('https://garith.be/b2/tmdb/api/discover/movie?with_genres=27&primary_release_year=2019')
.then((response) =>{
    return response.json();
  })
  .then((film) =>{
    const films = film.results;
    display(films, 'nouveautes');
  });
}

//pour créer ma liste

if(document.querySelector(".list")){
  const ul = document.querySelector(".list");
  let list = window.localStorage.getItem('movieList');
  let movieList = JSON.parse(list);
  
  movieList.forEach((id) => {
    const newUrl = 'https://garith.be/b2/tmdb/api/movie/'+id;
    fetch(newUrl).then((response) =>{
       return response.json();
     }).then((film) =>{
      //la valeur poster affichera d'office mon cover.jpg sauf si il a un poster
      let poster = `${window.location.origin}/assets/images/cover.jpg`;
      //si il y a un poster pour se film le prendre pour l'afficher
      if(film.poster_path){
        poster = `https://image.tmdb.org/t/p/w500${film.poster_path}`;
      }
      //on créé un li pour contenir nos éléments
      liElement = document.createElement('li');
      liElement.setAttribute('data-up', film.id);
      liElement.classList.add('list__el');
      //ce qu'on met dans notre element li
      liElement.innerHTML = `<img src="${poster}" /><h3 class="title_3"> ${film.title}</h3>`;
      ul.appendChild(liElement);
      console.log(liElement);

// on récupère la valeur de l'id du li sur lequel on a cliqué (film, titre, évaluation)

      liElement.addEventListener("click", (e) =>{
        let value = e.currentTarget.getAttribute('data-up');
        aMovie(value);
      })
     })
  })
}

// Afficher les films d'horreur qui vont bientôt sortir en 2020 dans la class bientot

if (document.querySelector(".bientot")){
  fetch('https://garith.be/b2/tmdb/api/discover/movie?with_genres=27&primary_release_year=2020')
.then((response) =>{
    return response.json();
  })
  .then((film) =>{
    const films = film.results;
    display(films, 'bientot');
  });
}





// fonction qui permet d'afficher les films dans l'accueil

function display(films, classHtml){
 	let ulElement = document.querySelector('.'+ classHtml);
	films.forEach(function(film){
      	let poster = `${window.location.origin}/assets/images/cover.jpg`;
      	if(film.poster_path){
		      poster = `https://image.tmdb.org/t/p/w500${film.poster_path}`;
        }

        liElement = document.createElement('li');

        liElement.setAttribute("data-up", film.id);

 
        liElement.classList.add(classHtml+'__el');

        liElement.innerHTML = `<img src="${poster}" /><h3 class="title_3"> ${film.title}</h3>`;
       ulElement.appendChild(liElement); 

       liElement.addEventListener("click", (e) =>{
          let value = e.currentTarget.getAttribute('data-up');
          aMovie(value);
        }) 
         		
  })

};

//Afficher les films tendances, ceux qui ont un vote average plus haut que les autres dans la class tendances


if (document.querySelector(".tendances")){
  fetch('https://garith.be/b2/tmdb/api/discover/movie?with_genres=27&sort_by=vote_average.desc&vote_count.gte=10')
.then((response) =>{
    return response.json();
})
.then((film) =>{
    const films = film.results;
    display(films, 'tendances');
});
}


//fonction qui permet d'afficher le film sélectionner

function aMovie(id){
  const url5 = 'https://garith.be/b2/tmdb/api/movie/'+id;
  fetch(url5).then((json) => {
  return json.json()
  }).then((film) =>{
    const containerFilm = document.querySelector('.content__film');
    
    let poster = `${window.location.origin}/assets/images/cover.jpg`;
        if(film.poster_path){
          poster = `https://image.tmdb.org/t/p/w500${film.poster_path}`;
    }
    const allFilms = document.querySelector('.content');
    const allContainer = document.querySelector('.container__content__film');
    containerFilm.innerHTML =  `<div class="film_content"><div class="flex_film"><div class="flex__el affiche"><img class="film_affiche" src="${poster}" /></div><div class="flex_el element_film"><h3 class="film_title"> ${film.title}</h3><p class="film_evaluation">Evaluation : ${film.popularity}</p><button class="ajouter film_ajouter">+ Add to my list</button><p class="film_resume hide3">Resume :</p><p class="film_resume__content hide3">${film.overview}</p></div></div></div><p class="film_resume hide2">Resume :</p><p class="film_resume__content hide2">${film.overview}</p>`;

    allFilms.classList.add('hidden');
    allContainer.classList.remove('hidden');
    const button = document.querySelector('.retour');
    button.addEventListener('click', function(){
      allFilms.classList.remove('hidden');
    allContainer.classList.add('hidden');
    })
    const btnAdd = document.querySelector('.ajouter');
    btnAdd.addEventListener('click', function(){
      addList(id);
    })  
  })
}


//tableau qui permet d'ajouter ou supprimer un film de ma liste

function addList(id){
  let list = window.localStorage.getItem('movieList');
  
  let movieList = JSON.parse(list);
    const filmDouble = [];
    const filmnew = [];
        if(!movieList){
        movieList = [];
    }
    movieList.forEach((data) => {
                if(data == id){
                 filmDouble.push('double');
                  }
            });
        if(filmDouble.length == 0){
            movieList.push(id);
            const addToLocal = JSON.stringify(movieList);
            localStorage.setItem('movieList', addToLocal);
        }else{

          for (let i = 0; i < movieList.length; i++) {
            if (movieList[i] == id){

            }else{
              filmnew.push(movieList[i]);
            }
          }
          const addToLocal = JSON.stringify(filmnew);
          localStorage.setItem('movieList', addToLocal);
        } 
  
}


if(document.querySelector('.search--content')){
  const search = document.querySelector('.search__field');
 
  urlSearch = 'https://garith.be/b2/tmdb/api/discover/movie?with_genres=27';
  fetch(urlSearch).then(response => response.json()).then(json =>{
    films = json.results;
    displaySearch(search.value);
  }) 

  search.addEventListener("input", (e) => {
    // On récupére la valeur contenue dans le champ de recherche.
    let value = e.currentTarget.value;
    // On utilise la fonction display movies (définie plus bas) pour afficher la liste des films en fonction de la valeur du champ de recherche
    displaySearch(value);
  });
}
// fonction qui permet d'afficher les films dans la page de recherche
function displaySearch(filter){
  const ulElement = document.querySelector('.search--content')
  if(films.length == 0){
    return;
  }
  let filterMovie = films.filter((movie) => {
    return movie.title.search(new RegExp(filter, "i")) > -1
  });
  ulElement.innerHTML = "";

  for(movie of filterMovie){
    // On récupère l'url du poster du film
    let poster = `${window.location.origin}/assets/images/cover.jpg`;
        if(movie.poster_path){
          poster = `https://image.tmdb.org/t/p/w500${movie.poster_path}`;
        }

        liElement = document.createElement('li');

        liElement.setAttribute("data-up", movie.id);
 
        liElement.classList.add('search__el');

        liElement.innerHTML = `<img src="${poster}" /><h3 class="title_3"> ${movie.title}</h3>`;
       ulElement.appendChild(liElement); 

       liElement.addEventListener("click", (e) =>{
          let value = e.currentTarget.getAttribute('data-up');
          aMovie(value);
        }) 
  }
}

const burger = document.querySelector('.burger');
const menu = document.querySelector('.menu');

var liElements= document.querySelectorAll('.li_burger');

console.log(burger);

burger.addEventListener('click', function(){
  menu.classList.toggle('menu--open'); //toogle pour que l'on puisse refermer le menu en appuyant sur le burger//
   burger.classList.toggle('burger--open');
});



for (let i = 0; i < liElements.length; i++) {
   liElements[i].addEventListener('click', function(){
      menu.classList.toggle('menu--open');
   })
}










